// extracted by mini-css-extract-plugin
export default {"content":"serviceUpdate_content__fOgrm","errorIcon":"serviceUpdate_errorIcon__YIxjd","message":"serviceUpdate_message__Q2IT9"};